import { Component, EventEmitter, Output } from '@angular/core';
import { ModalModule } from '@coreui/angular';

@Component({
  selector: 'app-session-modal',
  standalone: true,
  imports: [ModalModule],
  template: `
    <c-modal [(visible)]="visible" [keyboard]="false" [backdrop]="'static'">
      <c-modal-header>
        <strong>Session Expiring</strong>
      </c-modal-header>
      <c-modal-body>
        Your session is about to expire in <strong>{{ countdown }}</strong> seconds.
        <br />
        Do you want to stay logged in?
      </c-modal-body>
      <c-modal-footer>
        <button class="btn btn-primary" (click)="stayLoggedIn()">Stay Logged In</button>
        <button class="btn btn-danger" (click)="logout()">Logout</button>
      </c-modal-footer>
    </c-modal>
  `
})
export class SessionModalComponent {
  visible = false;
  countdown = 30;
  private timer: any;

  @Output() onRefresh = new EventEmitter<void>();
  @Output() onLogout = new EventEmitter<void>();

  show() {
    if (this.visible) return; // 🛡️ already shown, don’t restart
    this.clearTimer();
    this.visible = true;
    this.countdown = 30;

    this.timer = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
        this.logout();
        }
    }, 1000);
    }

  stayLoggedIn() {
    this.clearTimer();
    this.visible = false;
    this.onRefresh.emit();
  }

  logout() {
    this.clearTimer();
    this.visible = false;
    this.onLogout.emit();
  }

  private clearTimer() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }
}
